var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { CollapsiblePanel } from '../elements/collapsible-panel';
import { IconTextValue } from '../elements/icon-text-value';
import { useIcons } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { useManagement } from '../hooks/use-management';
var cls = classNames('indicator-panel');
export var SlicePanelLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var PanelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TextValueStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1.7em;\n    text-transform: uppercase;\n\n    ", "\n\n  "], ["\n    font-size: 1.7em;\n    text-transform: uppercase;\n\n    ", "\n\n  "])), function (_a) {
    var colors = _a.colors;
    return (colors === null || colors === void 0 ? void 0 : colors.text) && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      .shp--cell-header {\n        color: ", ";\n      }\n    "], ["\n      .shp--cell-header {\n        color: ", ";\n      }\n    "])), theme.COLOR(colors.text));
  })
});
// -------- Components -------->
var My = {
  Container: styled(CollapsiblePanel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TextValue: styled(IconTextValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TextValueStyles)
};
export var SlicePanelLayout = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    rest = __rest(props, ["className", "children", "entity"]);
  var t = useLang();
  var Icons = useIcons();
  var management = useManagement();
  var icon = entity.icon,
    title = entity.title,
    label = entity.label,
    name = entity.name;
  var Icon = Icons[icon === null || icon === void 0 ? void 0 : icon.component];
  return React.createElement(My.Container, __assign({}, rest, {
    disabled: management.canEdit,
    className: cls.name(className),
    head: React.createElement(My.TextValue, {
      iconComponent: Icon,
      iconSize: 60,
      label: label,
      colors: props.colors
    }, t(title)),
    body: children
  }));
};
SlicePanelLayout.defaultProps = SlicePanelLayoutDefaultProps;
SlicePanelLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;